import React, { useState } from "react";
import "./../styles/components/Footer.css";
import { FaFacebook, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";

const Footer = () => {
  const [modalContent, setModalContent] = useState(null);

  const openModal = (type) => {
    let content = null;

    if (type === "terms") {
      content = (
        <>
          <h2>📄 Site Guidelines</h2>
          <p>
            Welcome to Jai Vishwakarma Enterprises website. By accessing or using our
            website, you agree to the following guidelines:
          </p>
          <ul>
            <li>Use of Website – content is general info, no misuse allowed.</li>
            <li>Services Information – final details in official agreements.</li>
            <li>Third-Party Links – we’re not responsible for external sites.</li>
            <li>Limitation of Liability – we’re not liable for errors/damages.</li>
            <li>Governing Law – disputes under Delhi courts jurisdiction.</li>
          </ul>
        </>
      );
    } else if (type === "privacy") {
      content = (
        <>
          <h2>🔒 Privacy Policy</h2>
          <p>We respect your privacy. Details you share remain confidential.</p>
          <ul>
            <li>We collect personal info (name, email, phone) & analytics data.</li>
            <li>Used to serve you better & respond to inquiries.</li>
            <li>No selling/sharing to third parties, only trusted partners.</li>
            <li>Data protected with encryption & SSL.</li>
            <li>You may request correction/deletion anytime.</li>
          </ul>
        </>
      );
    } else if (type === "disclaimer") {
      content = (
        <>
          <h2>⚠️ Disclaimer</h2>
          <p>
            All construction projects vary based on site conditions, design requirements, and client specifications. Past performance does not guarantee future results.
          </p>
          <ul>
            <li>For specific guidance, quotations, or professional advice, please contact us directly.</li>
          </ul>
        </>
      );
    }

    setModalContent(content);
  };

  const closeModal = () => setModalContent(null);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left Section - Branding */}
        <div className="footer-section brand">
          <h2>Never Stop Building Your Dreams</h2>
          <p>
            <strong>Jai Vishwakarma Enterprises</strong> — Building trust with
            quality, care, and innovation since 2001.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#main">🏠 Home</a></li>
            <li><a href="#about">ℹ️ About Us</a></li>
            <li><a href="#Choose">⭐ Why Choose Us</a></li>
            <li><a href="#services">🛠 Services</a></li>
            <li><a href="#team">👷 Our Team</a></li>
            <li><a href="#blog">📰 Blog</a></li>
          </ul>
        </div>

        {/* Legal Section */}
        <div className="footer-section legal">
          <h3>Information</h3>
          <p onClick={() => openModal("terms")} className="collapsible">
            📄 Site Guidelines
          </p>
          <p onClick={() => openModal("privacy")} className="collapsible">
            🔒 Privacy Policy
          </p>
          <p onClick={() => openModal("disclaimer")} className="collapsible">
            ⚠️ Disclaimer
          </p>
        </div>

        {/* Safety Notice */}
        <div className="footer-section safety">
          <h3>⚠️ Safety Notice</h3>
          <p>
            Jai Vishwakarma Enterprises will never ask you to click links or share OTPs. 
            We will only contact you personally via phone. 
            Please stay alert and report any suspicious messages.
          </p>
        </div>

        {/* Stay Updated */}
        <div className="footer-section subscribe">
          <h3>Stay Updated</h3>
          <p>
            Subscribe to receive our latest updates, project news, and service
            offerings.
          </p>
          <form className="subscribe-form">
            <input type="email" placeholder="📧 Your Email" required />
            <button type="submit">👉 Subscribe</button>
          </form>
        </div>

        {/* Social Media */}
        <div className="footer-section social">
          <h3>Stay Connected</h3>
          <div className="social-icons">
            <a href=".." target="_blank" rel="noopener noreferrer">
              <FaFacebook />
            </a>
            <a href="https://www.instagram.com/jventerprises36?igsh=MTQwNzBwcjVkbnlucA==" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href=".." target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>
            <a href=".." target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
          </div>
        </div>

        {/* Managed By Section */}
        <div className="footer-section managed-by">
          <h3>Managed By</h3>
          <p>Owner: Mr. C.K. Mohanty</p>
           <p>
    Email:{" "}
    <a href="mailto:c.k.mohanty36@gmail.com" target="_blank" rel="noopener noreferrer">
      c.k.mohanty36@gmail.com
    </a>
  </p>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>All Rights Reserved © 2025 Jai Vishwakarma Enterprises</p>
      </div>

      {/* Modal Popup */}
      {modalContent && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>✖</button>
            {modalContent}
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
